import _define_property from "@swc/helpers/src/_define_property.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import "@blackbird/common/augmentations";
import React, { createContext, useCallback, useContext, useEffect, useReducer } from "react";
export var createStorageHook = function(storage) {
    var defaultValue = [
        {},
        function() {
            return undefined;
        }
    ];
    var StorageContext = /*#__PURE__*/ createContext(defaultValue);
    var getItem = function(key) {
        if ("object" === "undefined") {
            return;
        }
        var item = window[storage].getItem(key);
        if (!item) {
            return;
        }
        return JSON.parse(item);
    };
    var reducer = function(state, action) {
        if ("object" !== "undefined") {
            if (action.value === null || action.value === undefined) {
                window[storage].removeItem(action.key);
            } else {
                window[storage].setItem(action.key, JSON.stringify(action.value));
            }
        }
        return Object.assign(Object.assign({}, state), _define_property({}, action.key, action.value));
    };
    var useStorage = function(key, initialValue) {
        var _a, _b;
        var ref = useContext(StorageContext), state = ref[0], dispatch = ref[1];
        var value = (_b = (_a = state[key]) !== null && _a !== void 0 ? _a : getItem(key)) !== null && _b !== void 0 ? _b : initialValue;
        useEffect(function() {
            var absentKey = !(key in state);
            if (absentKey) {
                dispatch({
                    key: key,
                    value: value
                });
            }
        }, [
            state,
            dispatch
        ]);
        var setValue = useCallback(function(v) {
            try {
                var valueToStore = _instanceof(v, Function) ? v(value) : v;
                dispatch({
                    key: key,
                    value: valueToStore
                });
            } catch (_a) {}
        }, [
            dispatch
        ]);
        return [
            value,
            setValue
        ];
    };
    var withStorage = function(key, initialValue) {
        return function(Component) {
            return function(props) {
                var ref = _sliced_to_array(useStorage(key, initialValue), 2), value = ref[0], setValue = ref[1];
                var storageProperty = _define_property({}, storage, {
                    value: value,
                    setValue: setValue
                });
                return /*#__PURE__*/ React.createElement(Component, Object.assign({}, props, storageProperty));
            };
        };
    };
    var Storage = function(param) {
        var children = param.children;
        return /*#__PURE__*/ React.createElement(StorageContext.Provider, {
            value: useReducer(reducer, {})
        }, children);
    };
    return {
        Storage: Storage,
        StorageContext: StorageContext,
        useStorage: useStorage,
        withStorage: withStorage
    };
};
